module.exports = __webpack_public_path__ + "media/application/images/news/secondary_nav/what-they-say-ceb70281b98f296ffd40100120362e3d.jpg";